export class ModalPropsType {

  selectedCandidate: string;
  selectedJobOfferId: string;

}
